const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    shop_ids: {
      type: 'array',
      title: 'فروشگاه',
      items: [],
    },
    booth_ids: {
      type: 'array',
      title: 'غرفه',
      items: [],
    },
    brand_ids: {
      type: 'array',
      title: 'برند',
      items: [],
    },
    category_ids: {
      type: 'array',
      title: 'دسته بندی',
      items: [],
    },
    nulls: {
      type: 'array',
      title: 'فاقد',
      items: {
        type: 'string',
        enum: ['IMAGES', 'booth_id'],
        enumNames: ['تصویر', 'غرفه'],
      },
      uniqueItems: true,
      // default: 'IMAGES',
    },
    haves: {
      type: 'array',
      title: 'دارای',
      items: {
        type: 'string',
        enum: ['IMAGES', 'ATTRIBUTE'],
        enumNames: ['تصویر', 'ویژگی'],
      },
      uniqueItems: true,
    },
    is_packaged: {
      type: 'number',
      title: 'پکیج',
      oneOf: [
        { const: undefined, title: 'انتخاب نشده' },
        { const: 1, title: 'فقط پکیج' },
        { const: 0, title: 'بجز پکیج' },
      ],
    },
    has_wolesale_discount: {
      type: 'number',
      title: 'عمده',
      oneOf: [
        { const: undefined, title: 'انتخاب نشده' },
        { const: 1, title: 'فقط عمده' },
        { const: 0, title: 'بجز عمده' },
      ],
    },
    for_admin: {
      type: 'number',
      title: 'فروش',
      oneOf: [
        { const: undefined, title: 'انتخاب نشده' },
        { const: 1, title: 'قابل فروش' },
        { const: 0, title: 'غیرقابل فروش' },
      ],
    },
  },
});

export default schema;
